/* eslint-disable max-statements */
/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from 'react';
import '../styles.scss';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import Header from '../internalCommons/header';
import {vehiclesInventoryScreens} from '../../constants';
import VehiclesByLineTable from './vehiclesByLineTable';
import {useSearchParams} from 'react-router-dom';
import LoaderAllScreen from '../internalCommons/loaderAllScreen';

const VehiclesByLine = (props) => {
  const [filteredRows, setFilteredRows] = useState(props.modelsByLine);

  const [searchParams] = useSearchParams();
  const group = searchParams.get('group');
  const type = searchParams.get('type');
  const master = searchParams.get('master');
  const sfx = searchParams.get('sfx');
  const dealer = searchParams.get('dealer');
  const destiny = searchParams.get('destiny');

  const [filters, setFilters] = useState({
    'lessThan': false,
    'between': false,
    'greaterThan': false,
    'all': true,
  });

  const filterLines = {
    'master': master,
    'dealer': dealer,
    'destiny': destiny,
    'sfx': sfx,
    'group': group,
    'type': type,
  };

  useEffect(() => {
    props.fetchDealers('dealers-vehicles');
    props.fetchVehicleTypeCatalog();
    props.fetchModelsLinesByFilters(filterLines);
    props.fetchNotificationPrirization();
    props.setFilterInventory(filterLines);
  }, []);

  const generatefilteredRows = (key, value) => {
    let filterdData = [];
    const updatedFilters = {...filters, [key]: value};
    if (updatedFilters.lessThan) {
      filterdData.push(
        ...props.modelsByLine.filter((item) => item.daysOld < 30)
      );
    }
    if (updatedFilters.between) {
      filterdData.push(
        ...props.modelsByLine.filter(
          (item) => item.daysOld >= 30 && item.daysOld <= 60
        )
      );
    }
    if (updatedFilters.greaterThan) {
      filterdData.push(
        ...props.modelsByLine.filter((item) => item.daysOld > 60)
      );
    }
    if (updatedFilters.all) {
      filterdData = [...props.modelsByLine];
    }
    setFilteredRows(filterdData);
    props.updateTable();
    setFilters({
      ...filters,
      [key]: value,
    });
  };
  useEffect(() => {
    props.updateTable();
    const findKeyByValue = (obj) => {
      for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key]) {
          return [key, obj[key]];
        }
      }
    };
    const [currentFilter, value] = findKeyByValue(filters);
    generatefilteredRows(currentFilter, value);
  }, [props.modelsByLine]);
  return (
    <>
      <LoaderAllScreen active={props.loading} />
      <Header screen={vehiclesInventoryScreens.vehiclesByLineTable} />
      <div>
        <VehiclesByLineTable
          modelsByLine={filteredRows || []}
          group={group}
          filterLines={filterLines}
          filters={filters}
          generatefilteredRows={generatefilteredRows}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'modelsByLine': state.vehiclesInventory.modelsByLine,
    'excelData': state.vehiclesInventory.excelData,
    'loading': state.vehiclesInventory.loading,
    'notificationCount': state.vehiclesInventory.notificationCount,
    'notification': state.vehiclesInventory.notification,
     
  };
};

const {
  fetchDealers,
  fetchModelsLinesByFilters,
  fetchVehicleTypeCatalog,
  setFilterInventory,
  updateTable,
  fetchNotificationPrirization,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  fetchModelsLinesByFilters,
  fetchVehicleTypeCatalog,
  setFilterInventory,
  updateTable,
  fetchNotificationPrirization,
})(VehiclesByLine);
